import { TerminalTypeDtoToEntity } from "src/app/features/TerminalType/services/mappers/TerminalTypeDtoToEntity";
import type { TerminalTypeDto } from "src/app/features/TerminalType/types/TerminalTypeDto";
import type { TerminalTypeList } from "src/app/features/TerminalType/types/TerminalTypeList";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const TerminalTypeTableDtoMapper = (input: Readonly<ResourcePageDto<TerminalTypeDto>>): ResourcePageEntity<TerminalTypeList> => {
    return {
        // expose `key` as `keyProp` because antd Table overwrites the row's `key` with `id`
        list: input.list ? input.list.map((dto) => ({ ...TerminalTypeDtoToEntity(dto), keyProp: dto.key })) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
